import { render, staticRenderFns } from "./TeamAuditDocument.vue?vue&type=template&id=3224f94b&scoped=true"
import script from "./TeamAuditDocument.vue?vue&type=script&lang=js"
export * from "./TeamAuditDocument.vue?vue&type=script&lang=js"
import style0 from "./TeamAuditDocument.vue?vue&type=style&index=0&id=3224f94b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3224f94b",
  null
  
)

export default component.exports